import className from 'classnames/bind';
import { Event } from '@/__generated__/graphql';

import styles from './EventPricePills.module.scss';
import { usePageWrapperData } from '@/providers/PageWrapperContext';
const cx = className.bind(styles);

interface EventPricePillsProps {
  pricingType?: Event['eventData']['pricingType'];
  price?: Event['eventData']['price'];
  className?: string;
}

const getPricingPillData = ({ price, pricingType }: EventPricePillsProps) => {
  const { labels } = usePageWrapperData();
  const out: { label: string; }[] = [];
  if (!price || !pricingType) return out;
  const [type] = pricingType;
  const isTicketedEvent = type === 'ticketed'; 
  if (isTicketedEvent) {
    if (price.gaPrice) {
      out.push({ label: `${labels?.eventPriceLabels?.generalAdmission} $${price.gaPrice}` });
    }
    if (price.priceWithAdmission) {
      out.push({ label: `${labels?.eventPriceLabels?.priceWithAdmission} $${price.priceWithAdmission}` });
    }
    if (price.membersPrice) {
      out.push({ label: `${labels?.eventPriceLabels?.members} $${price.membersPrice}` });
    }
  } else {
    switch (type) {
      case 'free-with-rsvp':
        out.push({ label: labels?.eventPriceLabels?.freeWithRsvp });
        break;
      case 'free-with-admission':
        out.push({ label: labels?.eventPriceLabels?.freeWithAdmission });
        break;
      case 'free':
        out.push({ label: labels?.eventPriceLabels?.free });
        break;
      default:
        break;
    }
  }
  return out;
};

export default function EventPricePills({ className, pricingType, price }: EventPricePillsProps) {
  const pills = getPricingPillData({ pricingType, price });
  return (
    <div className={cx(["event-price-pills", className])}>
      {pills.map((pill, index) => (
        <span key={index} className={cx("pill")}>{pill.label}</span>
      ))}
    </div>
  )
}